/*
 * @Date: 2022-07-07 14:40:15
 * @LastEditors: guantingting
 * @LastEditTime: 2025-07-03 18:02:36
 */
export default [
  {
    path: '/rent/v2/vehicle-custody/user-custody',
    name: 'vehicleCustody',
    component: () => import('@/pages/vehicleCustody/userCustody'),
    meta: { title: '房车托管', requireAuth: true },
  },
  {
    path: '/rent/v2/vehicle-custody/managed-vehicles',
    name: 'managedVehicles',
    component: () => import('@/pages/vehicleCustody/managedVehicles'),
    meta: { title: '我的房车', requireAuth: true },
  },
  {
    path: '/rent/v2/vehicle-custody/vehicle-calendar',
    name: 'vehicleCalendar',
    component: () => import('@/pages/vehicleCustody/vehicleCalendar'),
    meta: { title: '预定日期', requireAuth: true },
  },
  {
    path: '/rent/v2/vehicle-custody/custody-order',
    name: 'custodyOrder',
    component: () => import('@/pages/vehicleCustody/custodyOrder'),
    meta: { title: '我的订单', requireAuth: true },
  },
  {
    path: '/rent/v2/vehicle-custody/accident',
    name: 'accident',
    component: () => import('@/pages/vehicleCustody/accident'),
    meta: { title: '车辆事故', requireAuth: true },
  },
  {
    path: '/rent/v2/vehicle-custody/violation',
    name: 'violation',
    component: () => import('@/pages/vehicleCustody/violation'),
    meta: { title: '车辆违章', requireAuth: true },
  },
  {
    path: '/rent/v2/vehicle-custody/upList',
    name: 'upList',
    component: () => import('@/pages/vehicleCustody/upList'),
    meta: { title: '上报记录', requireAuth: true },
  },
  {
    path: '/rent/v2/vehicle-custody/suggestions',
    name: 'suggestions',
    component: () => import('@/pages/vehicleCustody/suggestions'),
    meta: { title: '意见与建议', requireAuth: true },
  },
  {
    path: '/rent/v2/vehicle-custody/pushViolation',
    name: 'pushViolation',
    component: () => import('@/pages/vehicleCustody/pushViolation'),
    meta: { title: '上报违章', requireAuth: true },
  },
  {
    path: '/rent/v2/vehicle-custody/upDetail',
    name: 'upDetail',
    component: () => import('@/pages/vehicleCustody/upDetail'),
    meta: { title: '上报详情', requireAuth: true },
  },
  {
    path: '/rent/v2/vehicle-custody/maintain',
    name: 'maintain',
    component: () => import('@/pages/vehicleCustody/maintain'),
    meta: { title: '车辆保养', requireAuth: true },
  },
  {
    path: '/rent/v2/vehicle-custody/maintainDetail',
    name: 'maintainDetail',
    component: () => import('@/pages/vehicleCustody/maintainDetail'),
    meta: { title: '保养详情', requireAuth: true },
  },
  {
    path: '/rent/v2/vehicle-custody/repair',
    name: 'repair',
    component: () => import('@/pages/vehicleCustody/repair'),
    meta: { title: '车辆维修', requireAuth: true },
  },
  {
    path: '/rent/v2/vehicle-custody/repairDetail',
    name: 'repairDetail',
    component: () => import('@/pages/vehicleCustody/repairDetail'),
    meta: { title: '维修详情', requireAuth: true },
  },
  {
    path: '/rent/v2/vehicle-custody/income-all',
    name: 'incomeAll',
    component: () => import('@/pages/vehicleCustody/incomeAll'),
    meta: { title: '全部收益', requireAuth: true },
  },
  {
    path: '/rent/v2/vehicle-custody/income',
    name: 'income',
    component: () => import('@/pages/vehicleCustody/income'),
    meta: { title: '我的收益', requireAuth: true },
  },
  {
    path: '/rent/v2/vehicle-custody/income-detail',
    name: 'income-detail',
    component: () => import('@/pages/vehicleCustody/incomeDetail'),
    meta: { title: '收益明细', requireAuth: true },
  },
  {
    path: '/rent/v2/vehicle-custody/ownerApply',
    name: 'ownerApply',
    component: () => import('@/pages/vehicleCustody/ownerApply'),
    meta: { title: '房车托管', requireAuth: true },
  },
  {
    path: '/rent/v2/vehicle-custody/applyRecord',
    name: 'applyRecord',
    component: () => import('@/pages/vehicleCustody/applyRecord'),
    meta: { title: '房车托管', requireAuth: true },
  },
  {
    path: '/rent/v2/vehicle-custody/midPage',
    name: 'midPage',
    component: () => import('@/pages/vehicleCustody/midPage'),
    meta: { title: '房车托管', requireAuth: true },
  },
  {
    path: '/rent/v2/vehicle-custody/handle-account',
    name: 'handleAccount',
    component: () => import('@/pages/vehicleCustody/handleAccount'),
    meta: { title: '处理对账', requireAuth: true },
  },
  {
    path: '/rent/v2/vehicle-custody/upload-proof',
    name: 'uploadProof',
    component: () => import('@/pages/vehicleCustody/uploadProof'),
    meta: { title: '上传付款凭证', requireAuth: true },
  },
]



// WEBPACK FOOTER //
// ./src/pages/vehicleCustody/vehicleCustody.js